export class CitasPendientes {
  constructor(
    public LinkVideoLlamada?: string,
    public FechaCita?: Date,
    public HoraCita?: string,
    public MotivoCita?: string,
    public NombreEjecutivo?: string,
    public EmpRol?: number,
    public CodigoAsesoria?: number
  ) { }
}

export class AsesoriaVirtual {
  constructor(
    public CodigoAsesoria?: number,
    public MotivoCancelacion?: string
  ) { }

}


export class ComboSelect {
  constructor(
    public Codigo?: number,
    public Nombre?: string
  ) { }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/citas/citas-asesosr-virtual.entity.ts